export const geoApiOptions = {
    method: 'GET',
    headers: {
        'X-RapidAPI-Key': '43694f9f84mshe07afbb988d0f9ap1dc952jsnd8f6fbbc5e65',
        'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
    }
};

export const GEO_API_URL = 'https://wft-geo-db.p.rapidapi.com/v1/geo';

export const WEATHER_API_URL = 'https://api.openweathermap.org/data/2.5';

export const WEATHER_API_KEY = 'c6ceacf3a46058b163bb472b16c0d977';